import { notification } from 'antd';
import { call, debounce, put } from 'redux-saga/effects';

import { DEFAULT_DEBOUNCE_DELAY } from '#constants';
import GreyListService from '#services/GreyListService';

import { getGreyList, setGreyList, setLoading } from './';

function* getGreyListList(data) {
  try {
    yield put(setLoading(true));
    const agents = yield call(GreyListService.getList, data?.payload);
    yield put(setGreyList(agents));
  } catch (error) {
    notification.error({ message: error?.response?.data?.error?.message });
    yield put(setGreyList({ count: 0, result: [] }));
    yield put(setLoading(false));
  }
}

function* GreyListSaga() {
  yield debounce(DEFAULT_DEBOUNCE_DELAY, getGreyList.type, getGreyListList);
}

export default GreyListSaga;
